import { AuthorizationRoles, AuthService } from './auth-service';
import {TraceServiceBase} from './trace-service';

export class TraceServiceGA extends TraceServiceBase {

    constructor() {
        super();

        const gaTrackingId = (<any>window)["appenv"].services.traceservice.gaTrackingId;
        if (!gaTrackingId) {
            console.log('gaTrackingId is required in initialize()');
            return;
        }
        (window as any).ga('create',  gaTrackingId);

        // Only Voyage Team members have AllReadWrite
        // In GA all values must be strings, so converting true/false to string
        const userIsInternal = AuthService.userHasRole(AuthorizationRoles.AllReadWrite).toString();
        
        // This will set the dimension for all GA events and pageViews
        (window as any).ga('set', 'dimension1', userIsInternal);
    }

    pageView(path: string, title?: string) {
        // Required Fields
        const fieldObject: any = {
            hitType: 'pageview',
            page: path
        };

        // Optional Fields
        if (title) {
            fieldObject.title = title
        }

        (window as any).ga('send', fieldObject);
    };

    event(category: string, action: string, label?: string, value?: number) {
        // Required Fields
        const fieldObject: any = {
            hitType: 'event',
            eventCategory: category,
            eventAction: action
        };

        // Optional fields
        if (label) {
            fieldObject.eventLabel = label
        }
        if (typeof value !== 'undefined') {
            fieldObject.eventValue = value;
        }

        (window as any).ga('send', fieldObject);
    }
}
